// Formas de respuesta de la API de comercial (se declaran a mano, como en las
// otras apps; las peticiones sí van tipadas por el cliente RPC de Hono).

export type Etapa = "lead" | "oportunidad" | "propuesta" | "negociacion" | "ganado" | "perdido";
export type Nivel = "ejecutivo" | "subgerente" | "subdirector" | "director";
export type EstadoCotizacion = "borrador" | "autorizacion_pendiente" | "autorizada" | "enviada" | "aceptada" | "rechazada" | "vencida";
export type EstadoPropuesta = "borrador" | "enviada" | "vista" | "aceptada" | "cambios_pedidos" | "vencida";

export const ETAPAS: Etapa[] = ["lead", "oportunidad", "propuesta", "negociacion", "ganado", "perdido"];
export const ETIQUETA_ETAPA: Record<Etapa, string> = {
  lead: "Lead",
  oportunidad: "Oportunidad",
  propuesta: "Propuesta",
  negociacion: "Negociación",
  ganado: "Ganado",
  perdido: "Perdido",
};
export const ETIQUETA_NIVEL: Record<Nivel, string> = {
  ejecutivo: "Ejecutivo",
  subgerente: "Subgerente comercial",
  subdirector: "Subdirector comercial",
  director: "Director comercial",
};
export const ETIQUETA_ESTADO_COTIZACION: Record<EstadoCotizacion, string> = {
  borrador: "Borrador",
  autorizacion_pendiente: "Descuento por autorizar",
  autorizada: "Descuento autorizado",
  enviada: "Convertida en propuesta",
  aceptada: "Aceptada",
  rechazada: "Rechazada",
  vencida: "Vencida",
};
export const ETIQUETA_ESTADO_PROPUESTA: Record<EstadoPropuesta, string> = {
  borrador: "Borrador",
  enviada: "Enviada · sin abrir",
  vista: "Abierta · sin respuesta",
  aceptada: "Aceptada",
  cambios_pedidos: "Pidió cambios",
  vencida: "Vencida",
};

export interface Yo {
  id: string;
  correo: string;
  nombre: string;
  rol: string;
  areas: string[];
  nivel: Nivel;
  dev: boolean;
  config: ConfigAlertas;
}

export interface ConfigAlertas {
  diasInactividad: number;
  diasEscalamiento: number;
  umbralAltoValor: number;
}

export interface Alertas {
  diasSinActividad: number;
  vencida: boolean;
  detenida: boolean;
  escalar: boolean;
  enRiesgo: boolean;
}

export interface PersonaEquipo {
  id: string;
  nombre: string;
  puesto: string | null;
  correo: string;
  rol: string | null;
  area: string | null;
  jefeId: string | null;
}

export interface Producto {
  id: string;
  clave: string;
  nombre: string;
  familia: string | null;
  descripcion: string | null;
  precioLista: string | null;
  moneda: string;
  activo: boolean;
}

export interface CuentaLista {
  id: string;
  razonSocial: string;
  nombreComercial: string | null;
  rfc: string | null;
  segmento: string | null;
  estado: string;
  origen: string | null;
  ejecutivoId: string | null;
  ejecutivo: string | null;
  ultimaActividadEn: string | null;
  creadoEn: string;
  odooId: number | null;
  abiertas: number;
}

export interface Parecido {
  id: string;
  puntaje: number;
  nivel: "seguro" | "probable" | "posible";
  motivos: string[];
  cuenta: {
    id: string;
    razonSocial: string;
    nombreComercial: string | null;
    rfc: string | null;
    ejecutivo: string | null;
    ejecutivoId: string | null;
    estado: string;
    ultimaActividadEn: string | null;
  };
}

export interface Contacto {
  id: string;
  cuentaId: string;
  nombre: string;
  puesto: string | null;
  correo: string | null;
  telefono: string | null;
  principal: boolean;
}

export interface Actividad {
  id: string;
  tipo: string;
  fecha: string;
  resumen: string | null;
  resultado: string | null;
  automatica: boolean;
  hechaEn?: string | null;
  ejecutivo: string | null;
  escritaEnOdooEn?: string | null;
}

export interface OportunidadTarjeta {
  id: string;
  cuentaId: string;
  cuenta: string;
  nombre: string;
  etapa: Etapa;
  valor: string | null;
  moneda: string;
  probabilidad: number | null;
  fechaCierreEstimada: string | null;
  proximaAccion: string;
  proximaAccionFecha: string;
  ultimaActividadEn: string | null;
  altoValor: boolean;
  enRiesgo: boolean;
  productos: string[];
  origen: string | null;
  ejecutivoId: string | null;
  ejecutivo: string | null;
  odooId: number | null;
  cerradaEn: string | null;
  motivoPerdida: string | null;
  creadoEn: string;
  montoVisible: boolean;
  alertas: Alertas;
  propuesta: { id: string; estado: EstadoPropuesta; primeraAperturaEn: string | null; enviadaEn: string | null } | null;
}

export interface RespuestaOportunidades {
  oportunidades: OportunidadTarjeta[];
  resumen: { abiertas: number; detenidas: number; vencidas: number; escaladas: number; config: ConfigAlertas };
}

export interface CotizacionLista {
  id: string;
  folio: number;
  cuentaId?: string;
  cuenta?: string;
  oportunidadId?: string | null;
  oportunidad?: string | null;
  ejecutivoId: string | null;
  ejecutivo?: string | null;
  fecha: string;
  vigencia?: string | null;
  subtotal?: string;
  descuentoPct: string;
  total: string;
  estado: EstadoCotizacion;
  propuestaId?: string | null;
}

export interface PropuestaLista {
  id: string;
  titulo: string;
  estado: EstadoPropuesta;
  vigencia?: string | null;
  enviadaEn: string | null;
  primeraAperturaEn: string | null;
  aceptadaEn?: string | null;
  creadoEn?: string;
  cuentaId?: string;
  cuenta?: string;
  ejecutivoId: string | null;
  ejecutivo?: string | null;
  total?: string | null;
  aperturas?: number;
  segundos?: number;
  cotizacionId?: string | null;
}

export interface RespuestaCuenta {
  cuenta: {
    id: string;
    razonSocial: string;
    nombreComercial: string | null;
    rfc: string | null;
    telefono: string | null;
    correo: string | null;
    domicilio: string | null;
    segmento: string | null;
    origen: string | null;
    estado: string;
    ejecutivoId: string | null;
    ejecutivo: string | null;
    odooId: number | null;
    duplicadaDe: string | null;
    ultimaActividadEn: string | null;
    creadoEn: string;
  };
  contactos: Contacto[];
  oportunidades: (Omit<OportunidadTarjeta, "alertas" | "propuesta" | "cuenta" | "cuentaId" | "moneda" | "productos" | "altoValor" | "enRiesgo" | "origen" | "odooId" | "cerradaEn" | "motivoPerdida" | "probabilidad" | "fechaCierreEstimada"> & { montoVisible: boolean })[];
  cotizaciones: CotizacionLista[];
  propuestas: PropuestaLista[];
  actividades: Actividad[];
}

export interface RespuestaOportunidad {
  oportunidad: OportunidadTarjeta;
  actividades: Actividad[];
  cotizaciones: CotizacionLista[];
  propuestas: PropuestaLista[];
  contactos: Contacto[];
  odoo: EstadoOdoo;
  config: ConfigAlertas;
}

export interface EstadoOdoo {
  conectado: boolean;
  motivo: string | null;
  transporte: "json2" | "jsonrpc";
  ultimaSincronizacionEn?: string | null;
}

export interface Umbral {
  nivel: Nivel;
  pctMin: string | number;
  pctMax: string | number | null;
  activo: boolean;
}

export interface NivelRequerido {
  nivel: Nivel;
  porConfirmar: boolean;
  sinUmbrales: boolean;
  requiereAutorizacion: boolean;
}

export interface Totales {
  subtotal: number;
  descuentoMonto: number;
  descuentoPct: number;
  total: number;
  partidas: { cantidad: number; precioLista: number; descuentoPct: number; precioAplicado: number; importe: number }[];
}

export interface Autorizacion {
  id: string;
  porcentaje: string;
  nivelRequerido: Nivel;
  resultado: "pendiente" | "autorizada" | "rechazada";
  comentario: string | null;
  creadoEn: string;
  resueltaEn: string | null;
  autorizadoPor: string | null;
}

export interface RespuestaCotizacion {
  cotizacion: {
    id: string;
    folio: number;
    folioTexto: string;
    cuentaId: string;
    cuenta: string;
    oportunidadId: string | null;
    ejecutivoId: string | null;
    ejecutivo: string | null;
    fecha: string;
    vigencia: string | null;
    subtotal: string;
    descuentoPct: string;
    descuentoMonto: string;
    total: string;
    moneda: string;
    estado: EstadoCotizacion;
    notas: string | null;
    creadoEn: string;
  };
  partidas: {
    id: string;
    productoId: string | null;
    descripcion: string;
    cantidad: string;
    precioLista: string;
    precioAplicado: string;
    descuentoPct: string;
    importe: string;
    orden: number;
    producto: string | null;
  }[];
  autorizaciones: Autorizacion[];
  umbrales: Umbral[];
  porConfirmar: boolean;
  nivelRequerido: NivelRequerido;
  miNivel: Nivel;
  puedoFirmar: boolean;
  propuesta: { id: string; estado: EstadoPropuesta; enviadaEn: string | null } | null;
}

export interface AutorizacionPendiente {
  id: string;
  cotizacionId: string;
  folio: number;
  cuenta: string;
  total: string;
  porcentaje: string;
  nivelRequerido: Nivel;
  solicitadoPor: string | null;
  solicitante: string | null;
  resultado: string;
  creadoEn: string;
  puedoFirmar: boolean;
}

export interface Visitante {
  hash: string;
  dispositivo: string;
  primeraVez: string;
  ultimaVez: string;
  aperturas: number;
  segundos: number;
}

export interface Rastreo {
  abierta: boolean;
  primeraAperturaEn: string | null;
  ultimaAperturaEn: string | null;
  aperturas: number;
  segundosTotales: number;
  porSeccion: { seccion: string; segundos: number; pct: number }[];
  productos: { producto: string; vistas: number; segundos: number }[];
  visitantes: Visitante[];
  reenviada: boolean;
  aceptadaEn: string | null;
  cambios: { en: string; comentario: string | null }[];
  ultimoEventoEn: string | null;
}

export interface SeccionVersion {
  clave: string;
  titulo: string;
  html: string;
  productos?: string[];
}

export interface RespuestaPropuesta {
  propuesta: {
    id: string;
    titulo: string;
    estado: EstadoPropuesta;
    vigencia: string | null;
    versionActual: number;
    canalEnvio: string | null;
    enviadaEn: string | null;
    primeraAperturaEn: string | null;
    aceptadaEn: string | null;
    creadoEn: string;
    cuentaId: string;
    cuenta: string;
    cotizacionId: string | null;
    ejecutivoId: string | null;
    ejecutivo: string | null;
    total: string | null;
    folio: number | null;
    oportunidadId: string | null;
    liga: string;
    version: { id: string; numero: number; secciones: SeccionVersion[]; condiciones: string | null; total: string | null; creadoEn: string } | null;
  };
  rastreo: Rastreo;
  recorrido: { id: string; tipo: string; en: string; seccion: string | null; pais: string | null; userAgent: string | null; visitanteHash: string | null; detalle: Record<string, unknown> | null }[];
  contactos: Contacto[];
  ia: boolean;
}

export interface Aviso {
  id: string;
  titulo: string;
  texto: string | null;
  url: string | null;
  leidaEn: string | null;
  creadoEn: string;
  entidad: string | null;
  entidadId: string | null;
}

export interface RespuestaTablero {
  mes: string;
  etiquetaMes: string;
  corte: string;
  gerencia: boolean;
  vendedor: { id: string; nombre: string } | null;
  equipo: { id: string; nombre: string; puesto: string | null; rol: string | null }[];
  config: ConfigAlertas;
  preguntas: {
    porVendedor: { id: string; nombre: string; puesto: string | null; abiertas: number; lead: number; oportunidad: number; propuesta: number; negociacion: number; ganado: number; perdido: number }[];
    ventaMes: { cerrado: number; enNegociacion: number; ponderado: number; meta: number | null; avancePct: number | null };
    apoyo: { id: string; nombre: string; puntos: number; razones: string[] }[];
    detenidas: { id: string; cuenta: string; nombre: string; etapa: Etapa; dias: number; ejecutivo: string; valor: string | null; vencida: boolean; escalar: boolean }[];
    actividadesPorEjecutivo: { id: string; nombre: string; llamadas: number; visitas: number; reuniones: number; propuestas: number; correos: number; total: number }[];
    metas: { id: string; nombre: string; cerrado: number; meta: number | null; pct: number | null }[];
    enRiesgo: { id: string; tipo: "oportunidad" | "propuesta"; cuenta: string; valor: string | null; motivo: string; fuerte: boolean }[];
    conversion: {
      embudo: { de: string; a: string; pct: number | null }[];
      porEjecutivo: { id: string; nombre: string; ganadas: number; perdidas: number; pct: number | null }[];
      porProducto: { producto: string; propuestas: number; ganadas: number; pct: number | null }[];
      porPeriodo: { periodo: string; ganadas: number; perdidas: number; pct: number | null }[];
    };
  };
}
